import React from 'react'
import useTranslate from 'modules/local/useTranslate'

// Đánh dấu "Tu Sĩ" - hiện khi thành viên đang trong đời sống thánh hiến (is_religious, tính sẵn ở
// BE qua family_book_member_vocations, xem FamilyBookMemberTransformer(Tiny)). Cùng convention với
// PriestBadge.js (dùng chung cho mọi nơi hiện tên thành viên - Cây Gia Phả, Tâm Điểm, list Thành
// Viên..., không tự chế badge riêng mỗi nơi 1 kiểu) - đặt CẠNH PriestBadge chứ không thay thế, vì 1
// tu sĩ dòng có thể vừa là linh mục (is_priest) vừa là tu sĩ (is_religious), 2 field độc lập.
// TRƯỚC ĐÂY cố ý nhẹ hơn PriestBadge (tint viền, không nền đặc) - phản hồi thực tế thấy quá mờ nhạt
// cạnh badge Linh Mục (nền đặc bg-gray-800) - đổi sang nền đặc màu tím (bg-purple-700, KHÁC màu xám/
// đen của Linh Mục để phân biệt rõ 2 vai trò) để 2 badge cùng "trọng lượng" thị giác khi đứng cạnh
// nhau, không còn cái đậm cái mờ.
const ReligiousBadge = ({small, className = ''}) => {
    const t = useTranslate()
    return (
        <span
            className={`${small ? 'px-1 py-px text-4xs' : 'px-1.5 py-0.5 text-3xs'} rounded-full font-bold uppercase tracking-wide bg-purple-700 text-white whitespace-no-wrap ${className}`}>
            {t('religious member badge')}
        </span>
    )
}

export default ReligiousBadge
